import { render, staticRenderFns } from "./AddEditCategory.vue?vue&type=template&id=cd35f592&"
import script from "./AddEditCategory.vue?vue&type=script&lang=js&"
export * from "./AddEditCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports